import styled from "styled-components";

interface ContainerProps {
    lockScroll?: boolean;
}

export const Container = styled.div<ContainerProps>(({ theme, lockScroll }) => ({
    background: theme.colors[theme.colorMode].canvas_Primary,
    height: "100vh",
    ...(lockScroll && {
        overflow: "hidden" as const,
    }),
}));

export const ContainerHeader = styled.div(({ theme }) => ({
    display: "flex" as const,
    justifyContent: "center" as const,
    alignItems: "center" as const,
    width: "100%",
    overflow: "hidden" as const,
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const ContainerHeaderWrapper = styled.div(() => ({
    display: "flex" as const,
    justifyContent: "center" as const,
    flexDirection: "column" as const,
    alignItems: "flex-start" as const,
}));

export const ContainerHeaderSubtitle = styled.div(() => ({
    marginTop: "2px",
}));

export const CroutonWrapper = styled.div(() => ({
    bottom: "36px",
}));
